<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-07-07 14:35:37
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-08 14:15:25
-->
<template>
  <div class="label-wrapper">
    <div class="label-content">
      <van-sidebar v-model="active" @change="handleChange" style="flex-shrink:0;">
        <van-sidebar-item
          v-for="(item, index) in originList"
          :key="index"
          :title="item.categoryName" />
      </van-sidebar>
      <div style="width:100%;">
        <van-list class="list">
          <div v-if="list.length">
            <div v-for="item in list" :key="item.id" class="list-item">
              <div @click="handleSelectItem(item)" class="item-info van-hairline--bottom">
                <div style="display:flex;align-items:center;padding:5px 0;">
                  <span>{{item.name}}</span>
                </div>
                <van-icon v-if="item.show" name="success" color="#2695F1" />
              </div>
            </div>
          </div>
          <van-empty v-else description="暂无数据" />
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/index'
import { Toast } from 'vant'
import { mapState, mapMutations } from 'vuex'

export default {
  props: ['checked'],
  data() {
    return {
      active: 0,
      name: '',
      originList: [],
      list: []
    }
  },
  created() {
    if (this.checked) {
      this.fetchTagList()
      return
    }
    this.fetchLabelList()
  },
  computed: {
    ...mapState(['selectLabel', 'selectCircle'])
  },
  methods: {
    ...mapMutations(['updateSelectLabel']),
    init(val) {
      if (val) {
        this.fetchTagList()
        return
      }
      this.fetchLabelList()
    },
    fetchLabelList() {
      api.getLabelList().then(res => {
        const { code, data } = res
        if (code === 200) {
          this.originList = data
          this.list = data[0].labelList
        }
      })
    },
    fetchTagList() {
      this.originList = []
      this.list = []
      if (this.selectCircle.length) {
        const pros = []
        this.selectCircle.forEach(item => {
          let pro = new Promise((resolve) => {
            api.getTagList({ forumIds: item.id }).then(res => {
              const { code, data } = res
              if (code === 200) {
                resolve(data)
              }
            })
          })
          pros.push(pro)
        })
        Promise.all(pros).then(res => {
          res.forEach((item, index) => {
            const label = {}
            label.categoryName = this.selectCircle[index].name
            label.labelList = item
            this.originList.push(label)
          })
          this.list = this.originList[0].labelList
        })
      }
    },
    handleChange(index) {
      this.list = this.originList[index].labelList
    },
    handleSearch() {
      this.pageParams.page = 1
      this.fetchLabelList()
    },
    handleSelectItem(item) {
      const id = item.id
      if (this.selectLabel.find(i => i.id === id)) {
        const selectList = this.selectLabel.filter(i => i.id !== id)
        this.updateSelectLabel(selectList)
        this.list = this.list.map(i => {
          if (i.id === id) {
            i.show = false
          }
          return i
        })
      } else {
        if (this.selectLabel.length === 5) {
          Toast.fail('最多能选5个标签')
          return
        }
        this.updateSelectLabel([...this.selectLabel, item])
        this.list = this.list.map(i => {
          if (i.id === id) {
            i.show = true
          }
          return i
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.label-wrapper {
  background: #fff;
  height: 80vh;
  width: 100%;
  overflow: hidden;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  .label-content {
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  .list {
    height: 100%;
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    padding-bottom: 50px;
  }
  .item-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    // width: 100%;
    .item-avatar {
      margin-right: 10px;
    }
  }
  /deep/ .van-sidebar {
    width: 100px;
    height: 100vh;
    background: #f7f8fa;
  }
  /deep/ .van-sidebar-item--select {
    background-color: #f7f8fa;
  }
}
</style>